import styled from "styled-components";

export const StyledClock = styled.div`
    font-family: 'Roboto Mono', monospace;
    font-size: small;
    display: flex;
    justify-content: flex-end;
    padding: 10px;
`;
